import { render, staticRenderFns } from "./SelectShop.vue?vue&type=template&id=68ae0fa4&scoped=true"
import script from "./SelectShop.vue?vue&type=script&lang=js"
export * from "./SelectShop.vue?vue&type=script&lang=js"
import style0 from "./SelectShop.vue?vue&type=style&index=0&id=68ae0fa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae0fa4",
  null
  
)

export default component.exports